module.exports = __webpack_public_path__ + "static/material-badge-dot-6b8be1ab7de268d6c6f6330676774b4c.png";